import React, { ReactNode, useState } from 'react';
import { Button, Dimmer, Loader, Message } from 'semantic-ui-react';
import { useFacility } from '../../contexts/facility/FacilityContext';

const FacilityGate: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { facilityDetails, facilityTimezone, loading, refresh } = useFacility();
    const [retryingFacility, setRetryingFacility] = useState<boolean>(false);

    const retryFacility = async () => {
        setRetryingFacility(true);
        try {
            await refresh();
        } finally {
            setRetryingFacility(false);
        }
    };

    if (loading || retryingFacility) {
        return (
            <div style={{ position: 'relative', minHeight: '75vh', width: '100%' }}>
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            </div>
        );
    }

    if (!facilityDetails) {
        return (
            <Message negative>
                <p>Failed to fetch facility information.</p>
                <Button primary onClick={retryFacility}>Try again</Button>
            </Message>
        );
    }

    if (!facilityTimezone) {
        return (
            <Message warning>
                <p>Unable to fetch timezone of the facility. Please contact support.</p>
                <Button primary onClick={retryFacility}>Try again</Button>
            </Message>
        );
    }

    return <>{children}</>;
};

export default FacilityGate;
